import { jsx as _jsx } from "react/jsx-runtime";
import { PortableText as PortableTextReact } from '@portabletext/react';
import { PortableTextContext } from './portable-text-content';
import { globalComponents } from './portable-text-utils';
export const PortableText = ({ components, value, className, backgroundColor, ...rest }) => {
    if (!value) {
        return null;
    }
    return (_jsx(PortableTextContext.Provider, { value: { backgroundColor, components }, children: _jsx("div", { className: className, children: _jsx(PortableTextReact, { components: { ...globalComponents, ...components }, value: value, ...rest }) }) }));
};
export default PortableText;
